export const MOCK_USER = {
  type: "user",
  name: "welcomerct1",
  token: "test-token",
};
